import { AnnouncementDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { LatestNewsVM } from './LatestNewsVM';
import './LatestNews.scss';
import { LinkComp } from '../Links/extLink';
import Icon from '@mdi/react';
import { Popup } from 'cd-eft/components/common/Popup';
import { Table, Form, FormGroup, Col } from 'reactstrap';
import { Input } from 'cd-eft/components/common/Input/Input';
import { formatDate } from 'cd-eft/utils/formatDate';
import { mdiPlusCircle, mdiTrashCanOutline, mdiMinus, mdiPlus, mdiCircleSmall } from '@mdi/js';
import { Checkbox } from 'cd-eft/components/common/Checkbox/Checkbox';
import { Accordion } from '../Accordion';

interface ILatestNewsProps {
  announcementId?: number;
  announcementText?: string;
  announcementTextLink?: string;
  adminContent?: boolean;
  deleteClicked?: boolean;
  onData?: any;
  vm?: any;
  onEditData?: any;
  priority?: any
}

interface ILatestNews {
  adminContent?: boolean;
  collapseNewsCard?: any;
  newsContainer?: boolean;
}

interface ILatestNewsListProps {
  LatestNews?: AnnouncementDto[];
}

const SingleNews = (props: ILatestNewsProps) => {
  const vm = useRef(new LatestNewsVM()).current;

  const [checked, setChecked] = useState(false);
  const [editClicked, setEditClicked] = useState(false);

  const handleSelection = (e) => {
    setChecked(e.target.checked);
    props.onData(e.target.id, e.target.checked);
  };

  const handleEditClicked = (id) => {
    setEditClicked(!editClicked);
    props.onEditData(id);
  };

  return (
    <div>
      {props.deleteClicked ? (
        <div className="usa-checkbox check-label">
          <Checkbox
            classAdmin="admin-latestNews"
            label={props.announcementText}
            id={`${props.announcementId}`}
            checked={checked}
            name="selected"
            onChange={handleSelection}
          />
        </div>
      ) : (
        <div>
          {/* <div className="row pl-2 news-item"> */}
          <div className={`${props.adminContent ? 'news-item-card' : 'row pl-2 news-item'}`}>
            {props.priority ? <div>{props.priority}.&nbsp;</div> : <div>&nbsp;&nbsp;&nbsp;</div>}
            <LinkComp
              label={props.announcementText}
              labelClass={props.announcementTextLink}
              id={props.announcementId}
              adminContent={props.adminContent}
              onEditClicked={handleEditClicked}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const LatestNews = (props: ILatestNews) => {
  const vm = useRef(new LatestNewsVM()).current;
  vm.adminContent = props.adminContent

  useEffect(() => {
    vm.getLatestNews();
    vm.finalDeleteClicked = false;
    // setfinalDeleteClicked(false)
  }, [vm.finalDeleteClicked]);
  return (

    props.adminContent ? (
      <Accordion className="p-0 accordion-wrapper lastest-news-container" headers={['Latest News']} >
        <div className='sub-container'>
          <div className="action-menu-wrapper latest-news-wrapper">
            <button className="usa-button usa-button--outline add-card add-news" aria-label="Add latest news" onClick={vm.handleAddClicked}>
              <Icon path={mdiPlusCircle} size={1} /> Add
            </button>
            <button
              className="usa-button usa-button--unstyled delete-news"
              onClick={vm.handleDeleteClicked}
              aria-label="Delete latest news"
            >
              <Icon path={mdiTrashCanOutline} size={1} /> Delete{' '}
            </button>
          </div>
          <div className="news-container">
            {vm.addButtonClicked ? (
              <div>
                <Form className="add-edit-news-container add-text-label-text">
                  <FormGroup>
                    <Col>
                      <Input
                        label='Text:'
                        idAndName="announcementText"
                        type="text"
                        value={vm.newAnnouncement.announcementText}
                        required={true}
                        errorMsg={vm.formValidation.formErrors.announcementText}
                        valid={!vm.formValidation.announcementText}
                        className={vm.errorClass('announcementText')}
                        onChange={vm.handleInputChange}
                        autofocus={true}
                      />
                    </Col>
                    <Col>
                      <Input
                        label='URL Link:'
                        idAndName="announcementTextLink"
                        type="text"
                        value={vm.newAnnouncement.announcementTextLink}
                        required={true}
                        errorMsg={vm.formValidation.formErrors.announcementTextLink}
                        valid={!vm.formValidation.announcementTextLink}
                        className={vm.errorClass('announcementTextLink')}
                        onChange={vm.handleInputChange}
                      />
                    </Col>
                    <div className="add-edit-announcement-select">Display Priority on Home page</div>
                    <select
                      aria-label='display priority on homepage'
                      className="add-edit-announcement-select usa-select"
                      id="quick-select-options"
                      name="viewOrder"
                      value={vm.newAnnouncement.viewOrder}
                      onChange={vm.handleInputChange}
                    >
                      <option value="0">No Priority</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </FormGroup>
                </Form>
              </div>
            ) : null}
            {vm.addButtonClicked ? (
              <div className="save-button-container">
                <button className="usa-button usa-button--outline" aria-label="Cancel" onClick={vm.handleAddClicked}>
                  Close
                </button>
                <button disabled={vm.formValidation.hasError} className="usa-button" aria-label="Save" onClick={vm.toggleSavePopup}>
                  Save
                </button>
              </div>
            ) : null}
            {!props.newsContainer ? (
              <div className="update-table col usa-card__body news-items">
                {' '}
                {vm.adminContent ? (
                  <ul className='unorderedList'>
                    {vm.latestNews
                      ? vm.latestNews?.map((news) => (
                        <li className="usa-fieldset" key={news.announcementId}>
                          <SingleNews
                            announcementId={news.announcementId}
                            announcementText={news.announcementText}
                            announcementTextLink={news.announcementTextLink}
                            adminContent={props.adminContent}
                            deleteClicked={vm.deleteClicked}
                            onData={vm.handleDataFromChild}
                            onEditData={vm.handleEditClicked}
                            priority={news.viewOrder}
                          />
                        </li>
                      ))
                      : null}
                  </ul>
                )
                  :
                  (
                    <ul>
                      {vm.latestNews
                        ? vm.latestNews?.map((news) => (
                          <li className="usa-fieldset" key={news.announcementId}>
                            <SingleNews
                              announcementId={news.announcementId}
                              announcementText={news.announcementText}
                              announcementTextLink={news.announcementTextLink}
                              adminContent={props.adminContent}
                              deleteClicked={vm.deleteClicked}
                              onData={vm.handleDataFromChild}
                              onEditData={vm.handleEditClicked}
                            />
                          </li>
                        ))
                        : null}
                    </ul>
                  )}

              </div>
            ) : null}
            {/* add form */}


            {/* edit form */}
            {vm.editClicked ? (
              <div>
                <Form className="add-edit-news-container add-text-label-text">
                  <FormGroup>
                    <Col>
                      <Input
                        label='Text:'
                        idAndName="announcementText"
                        type="text"
                        value={vm.editAnnouncement.announcementText}
                        required={true}
                        errorMsg={vm.formValidation.formErrors.announcementText}
                        valid={!vm.formValidation.announcementText}
                        className={vm.errorClass('announcementText')}
                        onChange={vm.handleUpdateInputChange}
                        autofocus={true}
                      />
                    </Col>
                    <Col>
                      <Input
                        label='URL Link:'
                        idAndName="announcementTextLink"
                        type="text"
                        value={vm.editAnnouncement.announcementTextLink}
                        required={true}
                        errorMsg={vm.formValidation.formErrors.announcementTextLink}
                        valid={!vm.formValidation.announcementTextLink}
                        className={vm.errorClass('announcementTextLink')}
                        onChange={vm.handleUpdateInputChange}
                      />
                    </Col>
                    <div className="add-edit-announcement-select">Display Priority on Home page</div>
                    <select
                      aria-label='display priority on homepage'
                      className="add-edit-announcement-select usa-select"
                      id="quick-select-options"
                      name="viewOrder"
                      value={vm.editAnnouncement.viewOrder}
                      onChange={vm.handleUpdateInputChange}
                    >
                      <option value="0">No Priority</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </FormGroup>
                </Form>
              </div>
            ) : null}

            {vm.editClicked ? (
              <div className="save-button-container">
                <button className="usa-button usa-button--outline" aria-label="Cancel" onClick={vm.handleEditClicked}>
                  Close
                </button>
                <button disabled={vm.formValidation.hasError} className="usa-button" aria-label="Save" onClick={vm.toggleUpdateSavePopup}>
                  Save
                </button>
              </div>
            ) : null}



            {vm.deletePopup ? (
              <div>
                {vm.selectedData.length ? (
                  <div className="delete-popup">
                    <Popup
                      trigger={vm.deletePopup}
                      setTrigger={vm.toggleDeletePopup}
                      title="Delete Latest News?"
                      handleCancel={vm.toggleDeletePopup}
                      cancelText="Close"
                      handleOK={vm.deleteDataHandler}
                      okText="Delete"
                    >
                      {vm.selectedData.length === 1 ? (
                        <p>Are you sure you want to delete this latest news?</p>
                      ) : (
                        <p>Are you sure you want to delete these latest news?</p>
                      )}
                      {vm.checkedLatestnews.map((item) => (
                        <div
                          className={`${vm.selectedData?.length === 1
                            ? 'latestnews-single-comment-wrrapper'
                            : 'latestnews-delete-comment-wrraper'
                            } `}
                        >
                          <Table borderless>
                            <tbody>
                              <tr>
                                <th scope="row">Title</th>
                                <td className="name capitalize">{item.title}</td>
                              </tr>
                              <tr>
                                <th scope="row">Last Updated</th>
                                <td>{formatDate(item.lastChangeDate)}</td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      ))}
                    </Popup>
                  </div>
                ) : null}
              </div>
            ) : null}

            {vm.saveButtonPopup ? (
              <div className="delete-popup">
                <Popup
                  trigger={vm.saveButtonPopup}
                  setTrigger={vm.toggleSavePopup}
                  title="Add Latest News?"
                  handleCancel={vm.toggleSavePopup}
                  cancelText="Close"
                  handleOK={vm.addAnnouncementHandler}
                  okText="Save"
                >
                  <p>Are you sure you want to add this latest news?</p>
                  <Table borderless>
                    <tbody>
                      <tr>
                        <th scope="row">Text</th>
                        <td className="name capitalize">{vm.newAnnouncement.announcementText}</td>
                      </tr>
                      <tr>
                        <th scope="row">URL Link</th>
                        <td>{vm.newAnnouncement.announcementTextLink}</td>
                      </tr>
                      <tr>
                        <th scope="row">Priority:</th>
                        {vm.newAnnouncement.viewOrder == 0 ? <td>No Priority</td> : <td>{vm.newAnnouncement.viewOrder}</td>}
                        <td></td>
                      </tr>
                    </tbody>
                  </Table>
                </Popup>
              </div>
            ) : null}

            {vm.saveUpdateButtonPopup ? (
              <div className="delete-popup">
                <Popup
                  trigger={vm.saveUpdateButtonPopup}
                  setTrigger={vm.toggleUpdateSavePopup}
                  title="Update Latest News?"
                  handleCancel={vm.toggleUpdateSavePopup}
                  cancelText="Close"
                  handleOK={vm.updateAnnouncementHandler}
                  okText="Save"
                >
                  <p>Are you sure you want to update this latest news?</p>
                  <Table borderless>
                    <tbody>
                      <tr>
                        <th scope="row">Text</th>
                        <td className="name capitalize">{vm.editAnnouncement.announcementText}</td>
                      </tr>
                      <tr>
                        <th scope="row">URL Link</th>
                        <td>{vm.editAnnouncement.announcementTextLink}</td>
                      </tr>
                      <tr>
                        <th scope="row">Priority:</th>
                        {vm.editAnnouncement.viewOrder == 0 ? (
                          <td>No Priority</td>
                        ) : (
                          <td>{vm.editAnnouncement.viewOrder}</td>
                        )}
                      </tr>
                    </tbody>
                  </Table>
                </Popup>
              </div>
            ) : null}

            {vm.deleteClicked && (
              <div className="del-button-container">
                <button
                  className="usa-button usa-button--outline"
                  onClick={() => (vm.deleteClicked = !vm.deleteClicked)}
                  aria-label="Close"
                >
                  Close
                </button>

                {vm.selectedData.length ? (
                  <button className="usa-button" onClick={vm.toggleDeletePopup} aria-label="Delete">
                    Delete
                  </button>
                ) : null}
              </div>
            )}

          </div>
        </div>
      </Accordion>
    ) : (
      <Fragment>
        <div className="news-box mb-2  usa-card__container">
          <h3 className="usa-card__header" aria-label="latest news" tabIndex={0}>
            <strong>Latest News</strong>
          </h3>
          <div className="update-table col usa-card__body news-items">
            <ul>
              {vm.latestNews
                ? vm.latestNews?.map((news) => (
                  <li className="usa-fieldset" key={news.announcementId}>
                    <SingleNews
                      announcementId={news.announcementId}
                      announcementText={news.announcementText}
                      announcementTextLink={news.announcementTextLink}
                      adminContent={props.adminContent}
                      deleteClicked={vm.deleteClicked}
                      onData={vm.handleDataFromChild}
                      onEditData={vm.handleEditClicked}
                    />
                  </li>

                ))
                : null}
            </ul>
          </div>
        </div>
      </Fragment>
    )

  );
};

export const LatestNewsList = observer(LatestNews);
